import React, {
  FunctionComponent
  // useState,
  // useContext,
  // useMemo
  // useCallback
} from 'react';
import styles from './text-email-button-form.module.scss';
// import axios from 'axios';
// import Loader from 'react-loader-spinner';
// import { Button, IButtonProps } from '../../button/button';
// import { Input } from '../components/input/input';
// import { useGlobalTranslations } from '../../../hooks/use-global-translations';
// import { AppActionType, AppStore } from '../../../store/app.context';
// import { Checkbox, ICheckboxProps } from '../components/checkbox/checkbox';

export interface ITextEmailButtonFormProps {
  inputText: IInputProps[];
  postUrl: string;
  // submitButton: IButtonProps[];
  text: string;
  successMessage: string;
  lineUnderText: boolean;
  // checkboxes: ICheckboxProps[];
}

export interface IInputProps {
  label: string;
  errorMessage: string;
  required: boolean;
  type: string;
  name: string;
}

export const TextEmailButtonForm: FunctionComponent<ITextEmailButtonFormProps> = () =>
  // {
  //   inputText,
  //   postUrl,
  //   submitButton,
  //   text,
  //   lineUnderText,
  //   successMessage,
  //   checkboxes
  // }
  {
    // const {
    //   dispatch,
    //   state: { isLoading }
    // } = useContext(AppStore);
    // const [inputValue, setInputValue] = useState('');
    // const [checkIsValid, setCheckIsValid] = useState(false);
    // const [isError, setIsError] = useState(false);
    // const [formSend, setFormSend] = useState(false);
    // const { requestErrorText, mailSendSuccessMessage } = useGlobalTranslations();

    // const inputChangeHandler = (event: React.SyntheticEvent): void => {
    //   const target = event.target as HTMLInputElement;

    //   setInputValue(target.value);

    //   if (checkIsValid) {
    //     setIsError(false);
    //     setFormSend(false);
    //   }
    // };

    // const requestMessageText = useMemo(
    //   () =>
    //     isError
    //       ? requestErrorText
    //       : successMessage
    //       ? successMessage
    //       : mailSendSuccessMessage,
    //   [isError, mailSendSuccessMessage, requestErrorText, successMessage]
    // );

    // const submitHandler = async (event: React.FormEvent): Promise<void> => {
    //   const target = event.target as HTMLFormElement;

    //   event.preventDefault();
    //   setCheckIsValid(true);

    //   if (target.checkValidity()) {
    //     dispatch({ type: AppActionType.loading });

    //     try {
    //       await axios.post(postUrl, { email: inputValue });
    //       setCheckIsValid(false);
    //       setInputValue('');
    //       dispatch({ type: AppActionType.stopLoading });
    //       setFormSend(true);
    //       setIsError(false);
    //     } catch (error) {
    //       dispatch({ type: AppActionType.stopLoading });
    //       setIsError(true);
    //     }
    //   }
    // };

    // const checkboxHandler = useCallback(
    //   (event: React.SyntheticEvent): void => {
    //     console.log('checked');
    //   },
    //   [checkIsValid]
    // );
    // commented temporary, need to add error message

    return (
      <div className={styles.wrapper}>
        {/* {text && (
        <div
          className={`${styles.text} ${lineUnderText && styles.withUnderline}`}
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
      )} */}
        {/* <form
        onSubmit={submitHandler}
        noValidate
        className={`
        ${styles.form} 
        ${checkIsValid ? styles.formSubmitted : null}`}
      >
        <div className={styles.itemsWrapper}>
          {!isLoading ? (
            <React.Fragment>
              {inputText.map((item: IInputProps, i) => (
                <Input
                  {...item}
                  className={styles.input}
                  key={i}
                  value={inputValue}
                  type={'email'}
                  onChange={inputChangeHandler}
                />
              ))}
              <div
                className={`${styles.errorMessage} ${formSend &&
                  styles.successMessage} ${(isError || formSend) &&
                  styles.messageVisible}`}
              >
                {requestMessageText}
              </div>
              {checkboxes &&
                checkboxes.map((item: ICheckboxProps, i) => (
                  <Checkbox
                    key={i}
                    name={item.name}
                    label={item.label}
                    // value={checkIsValid || false}
                    // onChange={checkboxHandler}
                    checkIsValid={checkIsValid}
                    required={item.required}
                    displayOnInput={item.displayOnInput}
                  />
                ))}
              {submitButton.map((button: IButtonProps, i) => (
                <Button {...button} key={i} type="submit" />
              ))}
            </React.Fragment>
          ) : (
            <div className={styles.loader}>
              <Loader type="Oval" color="#e64510" height={50} width={50} />
            </div>
          )}
        </div>
      </form> */}
      </div>
    );
  };
// code above is commented temporary
// uncomment whene our own page /it-outsourcing-guide
// and corresponding getResponse form will work
